export default "__VITE_ASSET__axNh3ygA__"